import { post } from "../AxiosConfig";

/**
 * Factory function to create a service object with standard POST endpoints.
 *
 * @param {string} basePath - The base URL path (e.g. "agent", "bank").
 * @param {Object.<string, string>} endpoints - Map of method names to route suffixes.
 *   Each entry generates a method: (payload) => post(`/${basePath}/${route}`, payload)
 * @returns {Object} Service object with generated methods.
 *
 * @example
 *   const BankService = createCRUDService("bank", {
 *     listBanks: "list-bank",
 *     createBank: "create-bank",
 *   });
 *   // BankService.listBanks(payload) => post("/bank/list-bank", payload)
 */
export const createCRUDService = (basePath, endpoints = {}) => {
  const service = {};
  Object.entries(endpoints).forEach(([methodName, route]) => {
    service[methodName] = (payload) => post(`/${basePath}/${route}`, payload);
  });
  return service;
};
